export default __webpack_public_path__ + "static/media/app-store.243dde9c.svg";